import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const OldSiteBanner = () => {
  const [mounted, setMounted] = useState(false);
  const bannerRef = useRef(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    const banner = bannerRef.current;
    if (!banner) {
      return undefined;
    }

    const setBannerHeight = () => {
      document.documentElement.style.setProperty(
        "--old-site-banner-height",
        `${banner.offsetHeight}px`
      );
    };

    setBannerHeight();
    window.addEventListener("resize", setBannerHeight);

    return () => {
      window.removeEventListener("resize", setBannerHeight);
      document.documentElement.style.removeProperty("--old-site-banner-height");
    };
  }, [mounted]);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <aside
      ref={bannerRef}
      className="old-site-notice old-site-banner fixed top-0 left-0 right-0 z-[9998] px-4 py-4 md:px-6 md:py-5 text-center text-base md:text-lg lg:text-xl leading-snug select-text"
      role="note"
      aria-label="Old website notice"
    >
      You are viewing an old website of Ján Ďuraš (Jan Duras). Site has moved to{" "}
      <a
        href="https://janduras.com"
        className="old-site-notice__link font-semibold underline underline-offset-2"
        rel="noopener noreferrer"
      >
        janduras.com
      </a>
    </aside>,
    document.body
  );
};

export default OldSiteBanner;
